import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import {Icon, Button} from '../components/Button'
import {ImgFilters} from '../components/ImgFilters'
import {ChamadaAzul} from '../components/ChamadaAzul'
import {Tag} from '../components/Tag'
import {TransparencyFeo} from '../components/TransparencyFeo'
import {Depositions} from '../components/Depoimentos'
import imageEad from '../img/ead-02.png'
import icon01 from '../img/recorrence/icones-feo_professores.svg'
import icon01red from '../img/recorrence/icones-feo_group.svg'
import icon02 from '../img/recorrence/icones-feo_filtro.svg'
import icon02red from '../img/recorrence/icones-feo_pre-requisitos.svg'
import icon03 from '../img/recorrence/icones-feo_certificado.svg'
import icon03red from '../img/recorrence/icones-feo_informacoes-compiladas-PT.svg'
import icon04 from '../img/recorrence/icones-feo_edicoes-mensais.svg'
import icon04red from '../img/recorrence/icones-feo_filtro-1.svg'
import icon05 from '../img/recorrence/icones-feo_cursos.svg'
import icon05red from '../img/recorrence/icones-feo_telerreabilitacao.svg'
import icon13 from '../img/recorrence/icones-feo_alunos.svg'
import icon14 from '../img/recorrence/icones-feo_valores.svg'
import icon15 from '../img/recorrence/icones-feo_para-quem.svg'
import polygonPurple from '../img/recorrence/icones-feo_polygon1.png'
import polygonRed from '../img/recorrence/icones-feo_polygon2.png'
import {useConfigQuery} from '../utils/hooks/useConfigQuery'

const TagEmBreve = ({className}) => {
  const styles = clsx(
    `p-1 bg-white text-black border-error border-4 w-20 lg:w-24 text-sm lg:text-base font-black text-center`,
    className,
  )
  return <span className={styles}>Em breve</span>
}
const Hero = ({imgDesktop, imgMobile, tag, title, button}) => {
  return (
    <div className="relative w-full h-98">
      <ImgFilters img={imgMobile} transparency paralax className="lg:hidden" />
      <ImgFilters
        img={imgDesktop}
        transparency
        paralax
        className="hidden lg:block"
      />
      <div className="absolute inset-0 px-3 lg:px-36">
        <div className="grid gap-2.5 grid-cols-4 grid-flow-col mt-28 lg:grid-cols-12 lg:gap-4">
          <div className="col-start-2 col-end-5 lg:col-start-1 lg:col-end-8">
            <Tag variant="purple">{tag}</Tag>
          </div>
          <div className="text-2xl text-white col-start-1 col-end-5 lg:col-start-1 lg:col-end-13 font-baloo text-shadow">
            <Typography variant="heading-xl" className="lg:text-4xl">
              {title}
            </Typography>
          </div>
          <Button
            as="a"
            href={button.link}
            className="mt-4 uppercase col-start-1 col-end-5 lg:col-start-3 lg:col-end-11"
          >
            {button.label}
          </Button>
        </div>
      </div>
    </div>
  )
}

const Description = ({paragraph01, paragraph02, paragraph03}) => {
  return (
    <section className="mt-9">
      <div className="grid gap-2.5 grid-cols-4 grid-flow-col mt-28 lg:grid-cols-12 lg:gap-4 lg:h-80">
        <div className="z-10 col-start-1 col-end-5 lg:col-start-1 lg:col-end-7">
          <Typography
            as="p"
            size="lg"
            className="mb-4 text-center lg:text-left"
            weight="light"
          >
            {paragraph01}
          </Typography>
          <Typography
            as="p"
            size="lg"
            className="text-center lg:text-left"
            weight="light"
          >
            {paragraph02}
          </Typography>
        </div>
        <div className="relative col-start-1 col-end-5 lg:col-start-7 lg:col-end-13">
          <div className="w-full lg:w-600 lg:absolute lg:-top-8">
            <img src={imageEad} alt="" />
          </div>
        </div>
        <div className="z-10 col-start-1 col-end-5 lg:col-start-1 lg:col-end-7">
          <Typography
            as="p"
            className="md:text-center lg:text-left"
            weight="light"
          >
            {paragraph03}
          </Typography>
        </div>
      </div>
    </section>
  )
}
const Investment = ({
  investmentOldValue,
  investmentValue,
  investmentTotalValue,
  calltoAction,
  hotMktLink,
}) => {
  return (
    <div className="container relative px-10 overflow-hidden lg:px-auto">
      <section className="relative z-10 py-10">
        <div className="p-3 rounded-lg shadow-lg lg:max-w-5xl lg:p-5 relative grid gap-2.5 grid-cols-4 grid-flow-col lg:grid-cols-12 lg:gap-4 bg-white">
          <div className="pb-5 border-gray-500 lg:pb-0 col-start-1 col-end-5">
            <div className="flex">
              <div className="flex items-center">
                <Icon icon={icon14} />
              </div>
              <div className="ml-5">
                <Typography
                  as="p"
                  size="lg"
                  className="font-black uppercase color-gray-900"
                >
                  INVESTIMENTO
                </Typography>
                <Typography
                  as="p"
                  className="max-w-xs font-black uppercase color-gray-900"
                >
                  pagamento único com acesso por 12 meses
                </Typography>
              </div>
            </div>
            <div className="mt-4">
              <Typography className="line-through uppercase">
                de 12x R$ {investmentOldValue}
              </Typography>
            </div>
            <div>
              <Typography uppercase weight="black">
                Por apenas 12x R${' '}
                <Typography as="span" size="xl" weight="black">
                  {investmentValue}
                </Typography>
              </Typography>
            </div>
            {investmentTotalValue && (
              <div>
                <Typography uppercase weight="black">
                  Ou R${' '}
                  <Typography as="span" size="xl" weight="black">
                    {investmentTotalValue}{' '}
                  </Typography>
                  à vista
                </Typography>
              </div>
            )}
          </div>
          <div className="mt-5 lg:mt-0 lg:pl-5 col-start-1 col-end-5 lg:col-start-5 lg:col-end-11">
            <div className="flex">
              <div>
                <Icon icon={icon15} />
              </div>
              <div className="items-center ml-5 grid">
                <Typography
                  as="p"
                  size="lg"
                  className="font-black uppercase color-gray-900"
                >
                  PARA QUEM?
                </Typography>
              </div>
            </div>
            <div className="mt-4">
              <Typography className="max-w-xs">
                <Typography as="strong" weight="black" uppercase>
                  Estudantes
                </Typography>{' '}
                e{' '}
                <Typography as="strong" weight="black" uppercase>
                  profissionais de fisioterapia
                </Typography>{' '}
                que precisam de uma plataforma completa de atendimento e estudo
                na área de ortopedia, dor e traumatologia.
              </Typography>
            </div>
          </div>
          <div className="text-center col-start-1 col-end-5 lg:col-start-1 lg:col-end-11 lg:text-left">
            <div className="lg:absolute lg:right-0 lg:top-1/2 transform translate-y-7 lg:translate-x-2/4 lg:-translate-y-4">
              <Button
                as="a"
                type="button"
                className="uppercase p-9"
                href={hotMktLink}
              >
                {calltoAction}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <div className="absolute inset-0 z-0 w-full h-full overflow-hidden bg-right bg-no-repeat bg-cover">
        <TransparencyFeo
          className="absolute h-full -right-0 transform opacity-30 scale-300"
          color="#0095da"
        />
      </div>
    </div>
  )
}

export const RecorrencePageTemplate = ({
  heroBanner,
  investiment,
  paragraph01,
  paragraph02,
  paragraph03,
  community,
  blueCall,
}) => {
  const {studantCount} = useConfigQuery()
  const descriptionProps = {paragraph01, paragraph02, paragraph03}

  return (
    <div>
      <Hero {...heroBanner} />
      <div className="shadow-down">
        <div className="container px-10 pb-16 lg:px-auto">
          <Description {...descriptionProps} />
          <section>
            <div className="grid gap-2.5 grid-cols-4 grid-flow-col mt-28 lg:grid-cols-12 lg:gap-4">
              <div className="col-start-1 col-end-2">
                <Icon icon={icon13} />
              </div>
              <div className="col-start-2 col-end-5 lg:col-start-2 lg:col-end-9">
                <Typography as="p" size="lg" weight="light">
                  Comunidade com <br />
                  <Typography variant="heading" as="span" color="blue-500">
                    {studantCount}
                  </Typography>{' '}
                  fisioterapeutas em todo Brasil
                </Typography>
              </div>
              <div className="self-center text-center col-start-1 col-end-5 lg:col-start-9 lg:col-end-13">
                <Button
                  as="a"
                  type="button"
                  className="p-9"
                  background="bg-gray-100"
                  href={'/recorrencia-courses'}
                >
                  <Typography
                    as="span"
                    color="gray-900"
                    className="font-black uppercase"
                  >
                    conheça os nossos cursos
                  </Typography>
                </Button>
              </div>
            </div>
          </section>
          <section className="mt-20">
            <div className="relative bg-white z-2 lg:shadow-md lg:rounded-md">
              <div
                className="shadow-md lg:rounded-md absolute -top-3 w-screen -left-10 lg:w-full lg:left-3 h-2.5 lg:h-12 bg-purple-500"
                style={{zIndex: '-1'}}
              ></div>
              <div
                className="shadow-md lg:rounded-md absolute w-screen -left-10 lg:w-full lg:-left-3 -bottom-3 h-2.5 lg:h-12 bg-purple-500"
                style={{zIndex: '-1'}}
              ></div>
              <div
                className="absolute -bottom-7 left-1/2 transform -translate-x-8"
                style={{width: '64px', height: '17px', zIndex: '-1'}}
              >
                <img src={polygonPurple} alt="" />
              </div>
              <div className="flex items-center justify-between pt-3 pb-5">
                <div
                  className="w-6 lg:w-full"
                  style={{height: '4px', backgroundColor: '#bdbdbd'}}
                ></div>
                <h3 className="px-2 text-center lg:whitespace-nowrap">
                  <Typography
                    as="p"
                    size="lg"
                    className="font-black text-center text-purple-500 uppercase"
                  >
                    PARA VOCÊ SE APRIMORAR CONSTANTEMENTE
                  </Typography>
                </h3>
                <div
                  className="w-6 lg:w-full"
                  style={{height: '4px', backgroundColor: '#bdbdbd'}}
                ></div>
              </div>
              <div className="relative text-center pb-5 grid gap-2.5 grid-cols-4 grid-flow-col lg:grid-cols-12 lg:gap-4">
                <div className="items-center col-start-1 col-end-3 lg:col-start-2 lg:col-end-4">
                  <div className="mb-3">
                    <Icon icon={icon01} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center text-purple-500 uppercase"
                    >
                      PROFESSORES RENOMADOS
                    </Typography>
                  </div>
                </div>
                <div className="items-center col-start-3 col-end-5 lg:col-start-4 lg:col-end-6">
                  <div className="mb-3">
                    <Icon icon={icon02} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center text-purple-500 uppercase"
                    >
                      EVIDÊNCIAS CIENTÍFICAS
                    </Typography>
                    <p></p>
                  </div>
                </div>
                <div className="items-center col-start-1 col-end-3 lg:col-start-6 lg:col-end-8">
                  <div className="mb-3">
                    <Icon icon={icon03} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center text-purple-500 uppercase"
                    >
                      CURSOS COM CERTIFICAÇÃO
                    </Typography>
                  </div>
                </div>
                <div className="items-center col-start-3 col-end-5 lg:col-start-8 lg:col-end-10">
                  <div className="mb-3">
                    <Icon icon={icon04} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center text-purple-500 uppercase"
                    >
                      2 A 3 CURSOS NOVOS POR MÊS
                    </Typography>
                  </div>
                </div>
                <div className="items-center col-start-1 col-end-5 lg:col-start-10 lg:col-end-12">
                  <div className="mb-3">
                    <Icon icon={icon05} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center text-purple-500 uppercase"
                    >
                      GRUPOS DE ESTUDO
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="mt-20">
            <div className="relative bg-white z-2 lg:shadow-md lg:rounded-md">
              <div
                className="shadow-md lg:rounded-md absolute -top-3 w-screen -left-10 lg:w-full lg:left-3 h-2.5 lg:h-12 bg-error"
                style={{zIndex: '-1'}}
              ></div>
              <div
                className="shadow-md lg:rounded-md absolute w-screen -left-10 lg:w-full lg:-left-3 -bottom-3 h-2.5 lg:h-12 bg-error"
                style={{zIndex: '-1'}}
              ></div>
              <div
                className="absolute -bottom-7 left-1/2 transform -translate-x-8"
                style={{width: '64px', height: '17px', zIndex: '-1'}}
              >
                <img src={polygonRed} alt="" />
              </div>
              <div className="flex items-center justify-between pt-3 pb-5">
                <div className="w-6 h-1 bg-gray-100 lg:w-full"></div>
                <h3 className="px-2 text-center lg:whitespace-nowrap">
                  <Typography
                    as="p"
                    size="lg"
                    className="font-black text-center uppercase text-error"
                  >
                    PARA VOCÊ ATENDER MELHOR
                  </Typography>
                </h3>
                <div className="w-6 h-1 bg-gray-100 lg:w-full"></div>
              </div>
              <div className="relative text-center pb-5 grid gap-2.5 grid-cols-4 grid-flow-col lg:grid-cols-12 lg:gap-4">
                <div className="items-center col-start-1 col-end-3 lg:col-start-2 lg:col-end-4">
                  <div className="mb-3">
                    <Icon icon={icon01red} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center uppercase text-error"
                    >
                      MENTORIA COM NOSSOS PROFESSORES
                    </Typography>
                  </div>
                </div>
                <div className="relative items-center col-start-3 col-end-5 lg:col-start-4 lg:col-end-6">
                  <TagEmBreve className="absolute top-0 left-0 transform -rotate-12" />
                  <div className="mb-3">
                    <Icon icon={icon02red} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center uppercase text-error"
                    >
                      PRONTUÁRIO ELETRÔNICO & AGENDAMENTO
                    </Typography>
                    <p></p>
                  </div>
                </div>
                <div className="relative items-center col-start-1 col-end-3 lg:col-start-6 lg:col-end-8">
                  <TagEmBreve className="absolute top-0 left-0 transform -rotate-12" />
                  <div className="mb-3">
                    <Icon icon={icon03red} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center uppercase text-error"
                    >
                      AUXÍLIO NA TOMADA DE DECISÕES
                    </Typography>
                  </div>
                </div>
                <div className="relative items-center col-start-3 col-end-5 lg:col-start-8 lg:col-end-10">
                  <TagEmBreve className="absolute top-0 left-0 transform -rotate-12" />
                  <div className="mb-3">
                    <Icon icon={icon04red} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center uppercase text-error"
                    >
                      SUGESTÃO DE CURSOS DE ACORDO COM SEUS ATENDIMENTOS
                    </Typography>
                  </div>
                </div>
                <div className="relative items-center col-start-2 col-end-4 lg:col-start-10 lg:col-end-12">
                  <TagEmBreve className="absolute top-0 left-0 transform -rotate-12" />
                  <div className="mb-3">
                    <Icon icon={icon05red} />
                  </div>
                  <div>
                    <Typography
                      as="p"
                      className="font-black text-center uppercase text-error"
                    >
                      FERRAMENTA DE TELERREABILITAÇÃO E BANCO DE VÍDEOS
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Investment {...investiment} />
      <ChamadaAzul
        text={blueCall.text}
        linkText={blueCall.button}
        link={blueCall.link}
      />
      <Depositions />
    </div>
  )
}

const Template = ({pageContext}) => {
  return <RecorrencePageTemplate {...pageContext?.frontmatter} />
}

export default Template
